import React, { useMemo } from 'react'

import { useTranslation } from 'react-i18next'

import { useFilterBar } from '../../providers'

import { TabButton } from '../TabButton/TabButton'

import './FilterTabs.css'

export const FilterTabs = () => {
  const { t } = useTranslation('filterBar')

  const {
    selectedPath,
    mode,
    tabs,
    handleSelectedFilter,
    setSelectedPath,
    handleResetFilters,
  } = useFilterBar()

  const sortedTabs = useMemo(
    () => [...(tabs ?? [])].sort((a, b) => a.order - b.order),
    [tabs]
  )

  const handleTabClick = (path: string) => {
    setSelectedPath(path)
    handleResetFilters()
    handleSelectedFilter(false)
  }

  if (sortedTabs.length <= 1) return null

  return (
    <div className="will-filter-bar-tabs">
      {sortedTabs.map((tab) => (
        <TabButton
          key={tab.path}
          label={tab.label || t(`tabs.${tab.path.slice(1)}`)}
          onClick={() => handleTabClick(tab.path)}
          active={selectedPath === tab.path}
          mode={mode}
        />
      ))}
    </div>
  )
}
